import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

export enum CalculationType {
  Beef = 1,
  Sheep = 2,
}

class CalculationState {
  constructor (
    public type: CalculationType,
    public calculations: CalculationState[]
  ) {
    this.type = type
    this.calculations = calculations
  }
}

const calculations: { [index: number]: CalculationState } = {
  [CalculationType.Beef]: new CalculationState(CalculationType.Beef, []),
  [CalculationType.Sheep]: new CalculationState(CalculationType.Sheep, [])
}

const state = {
  activeTab: 0,
  calculations
}

const actions = {
  addCalculation ({ commit }, payload) {
    commit('mutateAddCalculation', payload)
  },
  removeCalculation ({ commit }, payload) {
    commit('mutateRemoveCalculation', payload)
  }
}

const mutations = {
  mutateAddCalculation ({ calculations }, calculation) {
    let calcType = calculations[calculation.type]
    if (!calcType) {
      calcType = new CalculationState(calculation.type, [calculation])
    } else {
      calcType.calculations.push(calculation)
    }
  },
  mutateRemoveCalculation ({ calculations }, calculation) {
    const calcType = calculations[calculation.type]
    if (calcType && calcType.calculations.indexOf(calculation) >= 0) {
      calcType.calculations.splice(calcType.calculations.indexOf(calculation), 1)
    }
  }
}

const getters = {
  getCalculations: state => (type: CalculationType) => state.calculations[type].calculations
}

const vuexPersist = new VuexPersist({
  key: 'mla-src',
  storage: window.localStorage
})

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexPersist.plugin]
})
